<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>Informar Disponibilidade</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuario.nome }}</p>
            <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
            <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
            <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <h3>Selecionar dia, turno e local</h3>
              <table
                aria-rowcount="4"
                id="my-table"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col">Períodos</th>
                    <th scope="col">Domingo</th>
                    <th scope="col">Segunda</th>
                    <th scope="col">Terça</th>
                    <th scope="col">Quarta</th>
                    <th scope="col">Quinta</th>
                    <th scope="col">Sexta</th>
                    <th scope="col">Sábado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><b>08:00 às 12:00</b></td>
                    <td class="action">
                      <span
                        v-if="semanaManha.domingo"
                        v-on:click="selecionarLocal('DOMINGO', 'MANHA')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaManha.segunda"
                        v-on:click="selecionarLocal('SEGUNDA', 'MANHA')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaManha.terca"
                        v-on:click="selecionarLocal('TERCA', 'MANHA')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaManha.quarta"
                        v-on:click="selecionarLocal('QUARTA', 'MANHA')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaManha.quinta"
                        v-on:click="selecionarLocal('QUINTA', 'MANHA')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaManha.sexta"
                        v-on:click="selecionarLocal('SEXTA', 'MANHA')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaManha.sabado"
                        v-on:click="selecionarLocal('SABADO', 'MANHA')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td><b>13:00 às 18:00</b></td>
                    <td class="action">
                      <span
                        v-if="semanaTarde.domingo"
                        v-on:click="selecionarLocal('DOMINGO', 'TARDE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaTarde.segunda"
                        v-on:click="selecionarLocal('SEGUNDA', 'TARDE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaTarde.terca"
                        v-on:click="selecionarLocal('TERCA', 'TARDE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaTarde.quarta"
                        v-on:click="selecionarLocal('QUARTA', 'TARDE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaTarde.quinta"
                        v-on:click="selecionarLocal('QUINTA', 'TARDE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaTarde.sexta"
                        v-on:click="selecionarLocal('SEXTA', 'TARDE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaTarde.sabado"
                        v-on:click="selecionarLocal('SABADO', 'TARDE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td><b>18:00 às 22:00</b></td>
                    <td class="action">
                      <span
                        v-if="semanaNoite.domingo"
                        v-on:click="selecionarLocal('DOMINGO', 'NOITE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaNoite.segunda"
                        v-on:click="selecionarLocal('SEGUNDA', 'NOITE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaNoite.terca"
                        v-on:click="selecionarLocal('TERCA', 'NOITE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaNoite.quarta"
                        v-on:click="selecionarLocal('QUARTA', 'NOITE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaNoite.quinta"
                        v-on:click="selecionarLocal('QUINTA', 'NOITE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaNoite.sexta"
                        v-on:click="selecionarLocal('SEXTA', 'NOITE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                    <td class="action">
                      <span
                        v-if="semanaNoite.sabado"
                        v-on:click="selecionarLocal('SABADO', 'NOITE')"
                        class="badge badge-success"
                        >Disponível</span
                      >
                      <span v-else class="badge badge-danger"
                        >Indisponível</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <br />
              <h3>Disponibilidade marcada</h3>
              <table
                aria-rowcount="4"
                id="my-table2"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col">Dia da semana</th>
                    <th scope="col">Turno</th>
                    <th scope="col">Local</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="minhasDisponibilidades.data !== undefined">
                  <tr
                    v-for="disponibilidade in minhasDisponibilidades.data"
                    :key="disponibilidade.id"
                  >
                    <td>
                      <span class="badge badge-pill">{{
                        disponibilidade.dia
                      }}</span>
                    </td>
                    <td>
                      <span class="badge badge-pill">{{
                        disponibilidade.periodo
                      }}</span>
                    </td>
                    <td>{{ disponibilidade.local }}</td>
                    <td style="width: 15%">
                      <a
                        class="btn btn-sm btn-secondary action"
                        title="Editar"
                        @click="
                          editarDisponibilidade(
                            disponibilidade.id,
                            disponibilidade.dia,
                            disponibilidade.periodo
                          )
                        "
                      >
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a
                        class="btn btn-sm btn-secondary action"
                        title="Excluir"
                        @click="
                          excluirDisponibilidade(disponibilidade.id, 'excluir')
                        "
                      >
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="7">Nenhum registro de disponibilidades...</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    <b-modal
      title="Selecione o Local"
      ok-title="Confirmar"
      cancel-title="Cancelar"
      v-model="modalCadastroOcupacao"
      @ok="modalSalvamentoDisponibilidade"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <p><b>Turno Selecionado:</b> {{ turnoSelecionado }}</p>
            </b-col>
            <b-col cols="12">
              <p><b>Horários:</b></p>
            </b-col>
            <b-col cols="12">
              <b-form-group v-if="horariosTurno === 'MANHA'">
                <b-form-checkbox-group
                  v-model="horariosSelecionados"
                  :state="horariosState"
                  :options="horarios.manha"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group v-if="horariosTurno === 'TARDE'">
                <b-form-checkbox-group
                  v-model="horariosSelecionados"
                  :state="horariosState"
                  :options="horarios.tarde"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group v-if="horariosTurno === 'NOITE'">
                <b-form-checkbox-group
                  v-model="horariosSelecionados"
                  :state="horariosState"
                  :options="horarios.noite"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label><b>Locais:</b></label>
                <b-form-select
                  v-model="local"
                  :state="localState"
                  placeholder="Password"
                  :options="locais"
                  class="mb-3"
                  @change="buscarDisponibilidadeLocal"
                >
                  <option selected :value="null">Selecione</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback5"
                  >Local é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
    <b-modal
      title="Editar Local"
      ok-title="Salvar"
      cancel-title="Cancelar"
      v-model="modalEdicaoOcupacao"
      @ok="modalSalvamentoDisponibilidadeEdicao"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <p><b>Turno Selecionado:</b> {{ turnoSelecionadoEdicao }}</p>
            </b-col>
            <b-col cols="12">
              <p><b>Horários:</b></p>
            </b-col>
            <b-col cols="12">
              <b-form-group v-if="horariosTurnoEdicao === 'MANHA'">
                <b-form-checkbox-group
                  v-model="horariosSelecionadosEdicao"
                  :state="horariosState"
                  :options="horarios.manha"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group v-if="horariosTurnoEdicao === 'TARDE'">
                <b-form-checkbox-group
                  v-model="horariosSelecionadosEdicao"
                  :state="horariosState"
                  :options="horarios.tarde"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group v-if="horariosTurnoEdicao === 'NOITE'">
                <b-form-checkbox-group
                  v-model="horariosSelecionadosEdicao"
                  :state="horariosEdicaoState"
                  :options="horarios.noite"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label><b>Locais:</b></label>
                <b-form-select
                  v-model="localEdicao"
                  :state="localState"
                  placeholder="Password"
                  :options="locais"
                  class="mb-3"
                >
                  <option selected :value="null">Selecione</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback5"
                  >Local é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
  </span>
</template>

<script>
import Vue from "vue";
import miniToastr from "mini-toastr";
import SessionStorage from "@/services/session-storage";

miniToastr.init();

export default {
  created() {
    if (SessionStorage.get("tipoPerfil").replace(/['"]+/g, "") === "V") {
      this.$store.dispatch("getUsuario", SessionStorage.get("usuario"));
      this.$store.dispatch(
        "buscarDisponibilidades",
        SessionStorage.get("usuario")
      );
    } else {
      this.$router.push("/");
    }
  },
  data() {
    return {
      totalPorPagina: 5,
      resource: "usuario",
      periodoCorrente: "",
      periodoCorrenteEdicao: "",
      disponibilidadeCorrenteId: null,
      diaCorrente: "",
      diaCorrenteEdicao: "",
      modalCadastroOcupacao: false,
      modalEdicaoOcupacao: false,
      turnoSelecionado: "",
      turnoSelecionadoEdicao: "",
      local: null,
      localEdicao: null,
      modalSelecionarLocal: false,
      ocupacao: {
        periodo: "",
        dia: "",
      },
      usuarioLogado: {
        municipio: "",
        estado: "",
        perfil: "",
      },
      semanaManha: {
        segunda: "",
        terca: "",
        quarta: "",
        quinta: "",
        sexta: "",
        sabado: "",
        domingo: "",
      },
      semanaTarde: {
        segunda: "",
        terca: "",
        quarta: "",
        quinta: "",
        sexta: "",
        sabado: "",
        domingo: "",
      },
      semanaNoite: {
        segunda: "",
        terca: "",
        quarta: "",
        quinta: "",
        sexta: "",
        sabado: "",
        domingo: "",
      },
      horariosSelecionados: [],
      horariosSelecionadosEdicao: [],
      horarios: {
        manha: [
          { text: "08:00 à 08:45", value: "8H" },
          { text: "09:00 à 09:45", value: "9H" },
          { text: "10:00 à 10:45", value: "10H" },
          { text: "11:00 à 11:45", value: "11H" },
        ],
        tarde: [
          { text: "13:00 à 13:45", value: "13H" },
          { text: "14:00 à 14:45", value: "14H" },
          { text: "15:00 à 15:45", value: "15H" },
          { text: "16:00 à 16:45", value: "16H" },
          { text: "17:00 à 17:45", value: "17H" },
        ],
        noite: [
          { text: "18:00 à 18:45", value: "18H" },
          { text: "19:00 à 19:45", value: "19H" },
          { text: "20:00 à 20:45", value: "20H" },
          { text: "21:00 à 21:45", value: "21H" },
        ],
      },
      horariosTurno: "",
      horariosTurnoEdicao: "",
      horariosState: null,
      horariosStateEdicao: null,
      horariosEdicaoState: null,
      localState: null,
      localEdicaoState: null,
    };
  },
  mounted() {
    this.verificaDomingoManha();
    this.verificaSegundaManha();
    this.verificaTercaManha();
    this.verificaQuartaManha();
    this.verificaQuintaManha();
    this.verificaSextaManha();
    this.verificaSabadoManha();
    this.verificaDomingoTarde();
    this.verificaSegundaTarde();
    this.verificaTercaTarde();
    this.verificaQuartaTarde();
    this.verificaQuintaTarde();
    this.verificaSextaTarde();
    this.verificaSabadoTarde();
    this.verificaDomingoNoite();
    this.verificaSegundaNoite();
    this.verificaTercaNoite();
    this.verificaQuartaNoite();
    this.verificaQuintaNoite();
    this.verificaSextaNoite();
    this.verificaSabadoNoite();
  },
  computed: {
    minhasDisponibilidades() {
      return this.$store.state.local.listaDisponibilidades;
    },
    usuario() {
      return this.$store.state.usuario.usuarioEditar;
    },
    localEditar() {
      return this.$store.state.local.localEditar;
    },
    disponibilidade() {
      return this.$store.state.local.disponibilidadeEditar;
    },
    locais() {
      return this.$store.state.local.listaLocais;
    },
  },
  watch: {
    "usuario.dados_pessoais.cidade": function () {
      this.usuarioLogado.municipio = this.usuario.dados_pessoais.cidade.cidade;
    },
    "usuario.dados_pessoais.cidade.estado": function () {
      this.usuarioLogado.estado =
        this.usuario.dados_pessoais.cidade.estado.estado;
    },
    "usuario.perfil": function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome;
    },
    usuario: function () {
      this.verificaDomingoManha();
      this.verificaSegundaManha();
      this.verificaTercaManha();
      this.verificaQuartaManha();
      this.verificaQuintaManha();
      this.verificaSextaManha();
      this.verificaSabadoManha();
      this.verificaDomingoTarde();
      this.verificaSegundaTarde();
      this.verificaTercaTarde();
      this.verificaQuartaTarde();
      this.verificaQuintaTarde();
      this.verificaSextaTarde();
      this.verificaSabadoTarde();
      this.verificaDomingoNoite();
      this.verificaSegundaNoite();
      this.verificaTercaNoite();
      this.verificaQuartaNoite();
      this.verificaQuintaNoite();
      this.verificaSextaNoite();
      this.verificaSabadoNoite();
    },
    disponibilidade: function () {
      this.zerarCampos();
      for (let i = 0; i < this.disponibilidade.horarios.length; i++) {
        if (this.disponibilidade.horarios[i]) {
          this.horariosSelecionadosEdicao.push(
            this.disponibilidade.horarios[i].horario
          );
        }
      }

      this.localEdicao = this.disponibilidade.ocupacao.local_id;
    },
  },
  methods: {
    excluirDisponibilidade(id) {
      this.$bvModal
        .msgBoxConfirm("Deseja realmente excluir essa disponibilidade?", {
          okTitle: "Confirmar",
          cancelTitle: "Cancelar",
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .get("api/local/voluntarios/disponibilidade/excluir/" + id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon("success", "i", { class: "fa fa-check" });
                  miniToastr.success(response.body.msg, "Sucesso!", 7000);
                  this.$store.dispatch(
                    "buscarDisponibilidades",
                    SessionStorage.get("usuario")
                  );
                }
              })
              .catch((erro) => {
                if (!erro.body.success) {
                  miniToastr.setIcon("error", "i", { class: "fa fa-check" });
                  miniToastr.error(erro.body.msg, "Alerta!", 7000);
                  this.$store.dispatch(
                    "buscarDisponibilidades",
                    SessionStorage.get("usuario")
                  );
                }
              });
          }
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    editarDisponibilidade(id, dia, periodo) {
      let data = {
        usuario_id: SessionStorage.get("usuario"),
        dia: dia,
        periodo: periodo,
      };

      this.$store.dispatch("buscarLocaisParaVoluntario", data);

      this.turnoSelecionadoEdicao = dia + " (" + periodo + ")";
      this.disponibilidadeCorrenteId = id;
      this.horariosTurnoEdicao = periodo;
      this.diaCorrenteEdicao = dia;
      this.periodoCorrenteEdicao = periodo;
      this.$store.dispatch("getDisponibilidade", id);
      this.modalEdicaoOcupacao = !this.modalEdicaoOcupacao;
    },
    verificaDomingoManha(dia = "DOMINGO", periodo = "MANHA") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaManha.domingo = response.data.data.permite;
        });
    },
    verificaSegundaManha(dia = "SEGUNDA", periodo = "MANHA") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaManha.segunda = response.data.data.permite;
        });
    },
    verificaTercaManha(dia = "TERCA", periodo = "MANHA") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaManha.terca = response.data.data.permite;
        });
    },
    verificaQuartaManha(dia = "QUARTA", periodo = "MANHA") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaManha.quarta = response.data.data.permite;
        });
    },
    verificaQuintaManha(dia = "QUINTA", periodo = "MANHA") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaManha.quinta = response.data.data.permite;
        });
    },
    verificaSextaManha(dia = "SEXTA", periodo = "MANHA") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaManha.sexta = response.data.data.permite;
        });
    },
    verificaSabadoManha(dia = "SABADO", periodo = "MANHA") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaManha.sabado = response.data.data.permite;
        });
    },
    verificaDomingoTarde(dia = "DOMINGO", periodo = "TARDE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaTarde.domingo = response.data.data.permite;
        });
    },
    verificaSegundaTarde(dia = "SEGUNDA", periodo = "TARDE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaTarde.segunda = response.data.data.permite;
        });
    },
    verificaTercaTarde(dia = "TERCA", periodo = "TARDE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaTarde.terca = response.data.data.permite;
        });
    },
    verificaQuartaTarde(dia = "QUARTA", periodo = "TARDE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaTarde.quarta = response.data.data.permite;
        });
    },
    verificaQuintaTarde(dia = "QUINTA", periodo = "TARDE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaTarde.quinta = response.data.data.permite;
        });
    },
    verificaSextaTarde(dia = "SEXTA", periodo = "TARDE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaTarde.sexta = response.data.data.permite;
        });
    },
    verificaSabadoTarde(dia = "SABADO", periodo = "TARDE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaTarde.sabado = response.data.data.permite;
        });
    },
    verificaDomingoNoite(dia = "DOMINGO", periodo = "NOITE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaNoite.domingo = response.data.data.permite;
        });
    },
    verificaSegundaNoite(dia = "SEGUNDA", periodo = "NOITE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaNoite.segunda = response.data.data.permite;
        });
    },
    verificaTercaNoite(dia = "TERCA", periodo = "NOITE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaNoite.terca = response.data.data.permite;
        });
    },
    verificaQuartaNoite(dia = "QUARTA", periodo = "NOITE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaNoite.quarta = response.data.data.permite;
        });
    },
    verificaQuintaNoite(dia = "QUINTA", periodo = "NOITE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaNoite.quinta = response.data.data.permite;
        });
    },
    verificaSextaNoite(dia = "SEXTA", periodo = "NOITE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaNoite.sexta = response.data.data.permite;
        });
    },
    verificaSabadoNoite(dia = "SABADO", periodo = "NOITE") {
      Vue.http
        .post("api/local/permitidos-para-usuario", {
          usuario_id: this.usuario.id,
          dia: dia,
          periodo: periodo,
        })
        .then((response) => {
          this.semanaNoite.sabado = response.data.data.permite;
        });
    },
    buscarDisponibilidadeLocal() {
      let data = {
        usuario_id: this.usuario.id,
        local_id: this.local,
        dia: this.diaCorrente,
        periodo: this.periodoCorrente,
      };

      Vue.http
        .post("api/local/voluntarios/disponibilidade-local", data)
        .then((response) => {
          if (response.data.data[0].horarios) {
            this.horariosSelecionados = [];
            for (let i = 0; i < response.data.data[0].horarios.length; i++) {
              if (response.data.data[0].horarios[i]) {
                this.horariosSelecionados.push(
                  response.data.data[0].horarios[i].horario
                );
              }
            }
            this.local = response.data.data[0].ocupacao.local_id;
          }
        });
    },
    selecionarLocal(dia, periodo) {
      this.turnoSelecionado = dia + " (" + periodo + ")";
      this.horariosTurno = periodo;
      this.diaCorrente = dia;
      this.periodoCorrente = periodo;

      let data = {
        usuario_id: SessionStorage.get("usuario"),
        dia: dia,
        periodo: periodo,
      };

      console.log(data);

      this.$store.dispatch("buscarLocaisParaVoluntario", data);
      this.zerarCampos();

      this.modalCadastroOcupacao = !this.modalCadastroOcupacao;
    },
    modalSalvamentoDisponibilidade(bvModalEvt) {
      let valid = true;

      if (!this.local) {
        this.localState = false;
        valid = false;
      } else {
        this.localState = true;
      }

      if (this.horariosSelecionados.length === 0) {
        this.horariosState = false;
        valid = false;
      } else {
        this.horariosState = true;
      }

      if (!valid) {
        bvModalEvt.preventDefault();
        return false;
      }

      this.handleSubmit();
    },
    modalSalvamentoDisponibilidadeEdicao(bvModalEvt) {
      let valid = true;

      if (!this.localEdicao) {
        this.localEdicaoState = false;
        valid = false;
      } else {
        this.localEdicaoState = true;
      }

      if (this.horariosSelecionadosEdicao.length === 0) {
        this.horariosEdicaoState = false;
        valid = false;
      } else {
        this.horariosEdicaoState = true;
      }

      if (!valid) {
        bvModalEvt.preventDefault();
        return false;
      }

      this.handleSubmitEdicao();
    },
    handleSubmit() {
      let data;

      data = {
        usuario_id: this.usuario.id,
        local_id: this.local,
        dia: this.diaCorrente,
        periodo: this.periodoCorrente,
        horarios: this.horariosSelecionados,
      };

      Vue.http
        .post("api/local/voluntarios/salvar", data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon("success", "i", { class: "fa fa-check" });
            miniToastr.success(response.body.msg, "Sucesso!", 4500);
            this.zerarCampos();
            this.$store.dispatch(
              "buscarDisponibilidades",
              SessionStorage.get("usuario")
            );
          } else {
            miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
            miniToastr.error(response.body.msg, "Alerta", 3500);
            this.zerarCampos();
          }
        })
        .catch((e) => {
          let response = e.body;

          if (response.msg) {
            miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
            miniToastr.error(response.msg, "Alerta!", 5000);
          }

          if (response.errors) {
            let erros = response.errors;

            if (erros.old_password !== undefined) {
              for (let erro of erros.old_password) {
                miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
                miniToastr.error(erro, "Alerta!", 15000);
              }
            }

            if (erros.new_password !== undefined) {
              for (let erro of erros.new_password) {
                miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
                miniToastr.error(erro, "Alerta!", 15000);
              }
            }

            if (erros.new_password_confirmation !== undefined) {
              for (let erro of erros.new_password_confirmation) {
                miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
                miniToastr.error(erro, "Alerta!", 15000);
              }
            }
          }

          this.zerarCampos();
        });
    },
    handleSubmitEdicao() {
      let data;

      data = {
        usuario_id: this.usuario.id,
        local_id: this.localEdicao,
        dia: this.diaCorrenteEdicao,
        periodo: this.periodoCorrenteEdicao,
        horarios: this.horariosSelecionadosEdicao,
      };

      Vue.http
        .put(
          "api/local/voluntarios/disponibilidade/editar/" +
            this.disponibilidadeCorrenteId,
          data
        )
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon("success", "i", { class: "fa fa-check" });
            miniToastr.success(response.body.msg, "Sucesso!", 4500);
            this.$store.dispatch(
              "buscarDisponibilidades",
              SessionStorage.get("usuario")
            );
            this.zerarCampos();
          } else {
            miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
            miniToastr.error(response.body.msg, "Alerta", 3500);
            this.zerarCampos();
          }
        })
        .catch((e) => {
          let response = e.body;

          if (response.msg) {
            miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
            miniToastr.error(response.msg, "Alerta!", 5000);
          }

          if (response.errors) {
            let erros = response.errors;

            if (erros.old_password !== undefined) {
              for (let erro of erros.old_password) {
                miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
                miniToastr.error(erro, "Alerta!", 15000);
              }
            }

            if (erros.new_password !== undefined) {
              for (let erro of erros.new_password) {
                miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
                miniToastr.error(erro, "Alerta!", 15000);
              }
            }

            if (erros.new_password_confirmation !== undefined) {
              for (let erro of erros.new_password_confirmation) {
                miniToastr.setIcon("error", "i", { class: "fa fa-warning" });
                miniToastr.error(erro, "Alerta!", 15000);
              }
            }
          }

          this.zerarCampos();
        });
    },
    zerarCampos() {
      this.local = null;
      this.localEdicao = null;
      this.horariosSelecionados = [];
      this.horariosSelecionadosEdicao = [];
      this.localState = null;
      this.localEdicaoState = null;
      this.horariosState = null;
      this.horariosEdicaoState = null;
    },
  },
};
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/voluntario/InformarDisponibilidade.vue